import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router, RouterModule } from "@angular/router"; // Added RouterModule for back link
import { AgoraService } from "../../services/agora.service";
import { AuthService } from "../../services/auth.service";
import { Stream, isStreamPaid } from "../../models/stream.model";
import { getCurrentUserId } from "../../helpers/utils";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PaymentModalComponent } from "../payment-modal/payment-modal.component";
import { LivePaymentService } from "../../services/live-payment.service";
import { NotificationService } from "../../services/notification.service";
import { FormsModule } from "@angular/forms";
import { Subscription } from "rxjs";
import { ChatComponent } from "../chat/chat.component";
import { HttpHeaders } from "@angular/common/http";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ViewersService, Viewer } from "../../services/viewers.service";
import { SecureStorageService } from "../../services/secure-storage.service";
import { ChatService } from "../../services/chat.service";
import { ShareModalComponent } from "../../components/share-modal/share-modal.component";
import { StreamService } from "../../services/stream.service";
import { STREAM_REPORT_REASONS } from "../../constants/stream-report-reasons";
import { formatStreamElapsed } from "../../helpers/utils";

@Component({
  selector: "app-viewer",
  standalone: true,
  imports: [CommonModule, FormsModule, ChatComponent, ShareModalComponent, RouterModule],
  template: `
    <div class="layout-wrapper">
      
      <a routerLink="/" class="back-link d-none d-lg-flex">
        <i class="fas fa-arrow-left"></i> Retour à l'accueil
      </a>

      <div class="viewer-card">
        <div class="left-column">
          
          <div class="video-wrapper">
            <div #remoteVideo id="remote-video" class="video-container">
              
              <div *ngIf="paymentRequired" class="video-placeholder payment-required">
                <div class="loader-content">
                  <i class="fas fa-lock"></i>
                  <span>Ce live est payant. Paiement en cours...</span>
                </div>
              </div>
              <div *ngIf="!isVideoInitialized && !autoplayFailed && !paymentRequired" class="video-placeholder">
                <div class="loader-content">
                  <i class="fas fa-spinner fa-spin"></i>
                  <span>Connexion au direct...</span>
                </div>
              </div>

              <div *ngIf="autoplayFailed" class="autoplay-overlay">
                <button (click)="playVideo()" class="big-play-btn">
                  <i class="fas fa-play"></i>
                </button>
                <p>Cliquez pour lancer la vidéo</p>
              </div>

              <div class="video-overlays" *ngIf="stream">
                
                <div class="live-status-bar">
                  <div class="profile-pill">
                    <img [src]="broadcasterProfilePicture" class="pill-avatar" alt="Avatar">
                    <span class="pill-name">{{ broadcasterName }}</span>
                    <span class="badge-live">EN DIRECT</span>
                    <span class="live-elapsed" *ngIf="liveElapsedDisplay">{{ liveElapsedDisplay }}</span>
                    <span class="viewer-pill">
                      <i class="fas fa-eye"></i> {{ viewerCount | number }}
                    </span>
                  </div>
                  
                  <button class="mobile-close-btn d-lg-none" (click)="leaveStream()">
                    <i class="fas fa-times"></i>
                  </button>
                </div>

              </div>
            </div>
          </div>

          <div class="stream-details-panel" *ngIf="stream">
            <div class="details-header">
              <h1 class="stream-title">Live de {{ broadcasterName }}</h1>
              <div class="stream-meta">
                <span><i class="fas fa-user-friends"></i> {{ viewerCount }} spectateurs</span>
                <span>•</span>
                <span *ngIf="liveElapsedDisplay"><i class="far fa-clock"></i> {{ liveElapsedDisplay }}</span>
                <span *ngIf="!liveElapsedDisplay">{{ stream.created_at | date : "shortTime" }}</span>
              </div>
            </div>
            
            <p class="stream-desc">{{ stream.description || 'Discussion exclusive et questions réponses avec les fans. Ne manquez pas ça!' }}</p>

            <div class="viewers-preview" *ngIf="viewers.length > 0">
               <span class="preview-label">Spectateurs:</span>
               <div class="avatars-stack">
                 <img *ngFor="let v of viewers.slice(0, 5)" [src]="v.profile_picture || 'assets/images/user-default.png'" [title]="v.name">
                 <div class="more-count" *ngIf="viewers.length > 5">+{{ viewers.length - 5 }}</div>
               </div>
            </div>

            <div class="action-row">
              <button class="btn-action btn-share" (click)="openShareModal()">
                <i class="fas fa-share"></i> Partager
              </button>
              <button
                *ngIf="canReportStream()"
                type="button"
                class="btn-action btn-report"
                (click)="openReportModal()"
              >
                <i class="fas fa-flag"></i> Signaler
              </button>
              <button class="btn-action btn-leave" (click)="leaveStream()">
                <i class="fas fa-sign-out-alt"></i> Quitter le live
              </button>
            </div>
          </div>

        </div>

        <div class="right-column">
          <div class="chat-header">
            <h3>Chat en direct</h3>
            <span class="live-badge-small">LIVE</span>
          </div>
          
          <div class="chat-wrapper-component">
            <app-chat
              *ngIf="isChatEnabled"
              [streamId]="slug"
              [viewerCount]="viewerCount"
              [currentUserId]="currentUserId"
            ></app-chat>
            
            <div *ngIf="!isChatEnabled" class="chat-disabled">
              <i class="fas fa-comment-slash"></i>
              <p>Le chat est désactivé.</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="mobile-controls d-lg-none">
       <button class="mob-btn share" (click)="openShareModal()"><i class="fas fa-share-alt"></i></button>
       <button *ngIf="canReportStream()" type="button" class="mob-btn report" (click)="openReportModal()">
         <i class="fas fa-flag"></i>
       </button>
       <button class="mob-btn like"><i class="fas fa-heart"></i></button>
    </div>

    <div class="report-modal-backdrop" *ngIf="showReportModal" (click)="closeReportModal()"></div>
    <div class="report-modal" *ngIf="showReportModal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <h3>Signaler ce live</h3>
      <p class="report-hint">Choisissez un motif. Vous ne pouvez signaler qu’une fois par live.</p>
      <div class="report-reasons">
        <label *ngFor="let r of reportReasons" class="report-reason-item">
          <input type="radio" name="reportReason" [(ngModel)]="selectedReportReason" [value]="r.code" />
          <span>{{ r.label }}</span>
        </label>
      </div>
      <textarea
        class="report-details"
        [(ngModel)]="reportDetails"
        rows="3"
        placeholder="Précisions (optionnel)"
        maxlength="2000"
      ></textarea>
      <div class="report-actions">
        <button type="button" class="btn-cancel" (click)="closeReportModal()">Annuler</button>
        <button
          type="button"
          class="btn-submit"
          [disabled]="!selectedReportReason || submittingReport"
          (click)="submitReport()"
        >
          {{ submittingReport ? 'Envoi…' : 'Envoyer' }}
        </button>
      </div>
    </div>

    <div class="report-modal-backdrop" *ngIf="showStreamEndedModal"></div>
    <div class="report-modal stream-ended-modal" *ngIf="showStreamEndedModal" role="dialog" aria-modal="true">
      <h3>Live terminé</h3>
      <p class="report-hint">{{ streamEndedMessage }}</p>
      <div class="report-actions">
        <button type="button" class="btn-submit" (click)="onStreamEndedOk()">OK</button>
      </div>
    </div>

    <app-share-modal
      [isOpen]="showShareModal"
      [shareUrl]="shareUrl"
      [title]="shareTitle"
      (closeModal)="closeShareModal()"
    ></app-share-modal>
  `,
  styles: [
    `
    /* --- Layout Global --- */
    .layout-wrapper {
      min-height: 100vh;
      background-color: #f0f2f5;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px;
    }

    .back-link {
      align-self: flex-start;
      margin-left: max(5%, 20px);
      margin-bottom: 15px;
      color: #FF4D67;
      font-weight: 600;
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
    }

    /* --- La Carte Principale (Desktop) --- */
    .viewer-card {
      width: 100%;
      max-width: 1400px;
      height: 85vh;
      background: #fff;
      border-radius: 24px;
      box-shadow: 0 20px 60px rgba(0,0,0,0.1);
      display: flex;
      overflow: hidden;
    }

    /* --- Colonne Gauche (Vidéo + Infos) --- */
    .left-column {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 0; /* Fix flex overflow */
      background: #fff;
    }

    .video-wrapper {
      flex: 2; /* Prend 2/3 de la hauteur sur la gauche */
      background: #000;
      position: relative;
      overflow: hidden;
      margin: 16px;
      border-radius: 16px;
    }

    .video-container {
      width: 100%;
      height: 100%;
      position: relative;
    }

    .stream-details-panel {
      padding: 10px 24px 24px;
      background: #fff;
    }

    .details-header {
      margin-bottom: 8px;
    }

    .stream-title {
      font-size: 1.5rem;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0;
    }

    .stream-meta {
      font-size: 0.9rem;
      color: #666;
      display: flex;
      gap: 10px;
      margin-top: 5px;
    }

    .stream-desc {
      color: #555;
      font-size: 0.95rem;
      margin-bottom: 20px;
      line-height: 1.5;
    }

    /* --- Colonne Droite (Chat) --- */
    .right-column {
      width: 400px;
      border-left: 1px solid #eee;
      display: flex;
      flex-direction: column;
      background: #fff;
    }

    .chat-header {
      padding: 20px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .chat-header h3 {
      font-size: 1.1rem;
      font-weight: 700;
      margin: 0;
    }

    .live-badge-small {
      background: #ffebeb;
      color: #FF4D67;
      padding: 4px 8px;
      border-radius: 6px;
      font-size: 0.75rem;
      font-weight: 700;
    }

    .chat-wrapper-component {
      flex: 1;
      overflow: hidden;
      position: relative;
    }

    /* --- Overlays Vidéo --- */
    .profile-pill {
      position: absolute;
      top: 20px;
      left: 20px;
      background: rgba(0, 0, 0, 0.6);
      backdrop-filter: blur(10px);
      padding: 6px 16px 6px 6px;
      border-radius: 30px;
      display: flex;
      align-items: center;
      gap: 10px;
      color: white;
      z-index: 10;
    }

    .pill-avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 2px solid #FF4D67;
    }

    .pill-name {
      font-weight: 600;
      font-size: 0.9rem;
    }

    .badge-live {
      background: #FF4D67;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 0.7rem;
      font-weight: 800;
      letter-spacing: 0.5px;
    }

    .live-elapsed {
      font-size: 0.8rem;
      font-weight: 700;
      font-variant-numeric: tabular-nums;
      letter-spacing: 0.03em;
    }
    
    .viewer-pill {
      font-size: 0.8rem;
      opacity: 0.9;
      margin-left: 5px;
    }

    /* --- Boutons Action --- */
    .action-row {
      display: flex;
      gap: 15px;
      margin-top: 15px;
    }

    .btn-action {
      flex: 1;
      padding: 12px;
      border-radius: 12px;
      border: none;
      font-weight: 600;
      font-size: 1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      transition: all 0.2s;
    }
    .btn-report {
      background: #fff;
      color: #b45309;
      border: 1px solid #fcd34d;
    }
    .btn-report:hover {
      background: #fffbeb;
    }
    .report-modal-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;
    }
    .report-modal {
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1001;
      background: #fff;
      border-radius: 16px;
      padding: 24px;
      max-width: 420px;
      width: calc(100% - 32px);
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
    }
    .report-modal h3 {
      margin: 0 0 8px 0;
      font-size: 1.2rem;
    }
    .report-hint {
      font-size: 0.85rem;
      color: #666;
      margin: 0 0 16px 0;
    }
    .report-reasons {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 12px;
      max-height: 220px;
      overflow-y: auto;
    }
    .report-reason-item {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      font-size: 0.9rem;
      cursor: pointer;
    }
    .report-details {
      width: 100%;
      border: 1px solid #ddd;
      border-radius: 8px;
      padding: 8px;
      margin-bottom: 16px;
      resize: vertical;
      font-family: inherit;
    }
    .report-actions {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
    }
    .report-actions .btn-cancel {
      padding: 10px 16px;
      border: 1px solid #ddd;
      border-radius: 8px;
      background: #fff;
      cursor: pointer;
    }
    .report-actions .btn-submit {
      padding: 10px 16px;
      border: none;
      border-radius: 8px;
      background: #ff4d67;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
    }
    .report-actions .btn-submit:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .btn-share {
      background: #3B82F6;
      color: white;
    }
    .btn-share:hover { background: #2563EB; }

    .btn-leave {
      background: #EF4444;
      color: white;
    }
    .btn-leave:hover { background: #DC2626; }

    /* --- Loading & Autoplay States --- */
    .video-placeholder, .autoplay-overlay {
      position: absolute;
      inset: 0;
      background: #000;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: white;
      z-index: 5;
    }
    .video-placeholder.payment-required .loader-content i {
      font-size: 48px;
      margin-bottom: 12px;
      color: #FF4D67;
    }
    .big-play-btn {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: rgba(255,255,255,0.2);
      border: 2px solid white;
      color: white;
      font-size: 30px;
      cursor: pointer;
      margin-bottom: 15px;
      transition: transform 0.2s;
    }
    .big-play-btn:hover { transform: scale(1.1); background: rgba(255,255,255,0.3); }

    /* --- Viewers Stack --- */
    .viewers-preview {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 15px;
      padding: 10px;
      background: #f9f9f9;
      border-radius: 10px;
      width: fit-content;
    }
    .avatars-stack { display: flex; }
    .avatars-stack img {
      width: 30px; height: 30px; border-radius: 50%; border: 2px solid #fff; margin-left: -10px;
    }
    .avatars-stack img:first-child { margin-left: 0; }
    .more-count {
      width: 30px; height: 30px; border-radius: 50%; background: #eee; color: #666;
      display: flex; align-items: center; justify-content: center; font-size: 0.7rem; font-weight: bold;
      margin-left: -10px; border: 2px solid #fff;
    }

    /* =========================================
       RESPONSIVE MOBILE (Max 991px) 
       ========================================= */
    @media (max-width: 991px) {
      .layout-wrapper {
        padding: 0;
        background: #000;
        height: 100vh; /* Fallback */
        height: 100dvh;
      }

      .viewer-card {
        border-radius: 0;
        height: 100%;
        max-width: 100%;
        flex-direction: column;
        position: relative;
      }

      .left-column {
        flex: auto;
        position: absolute;
        inset: 0;
        z-index: 1;
        background: #000;
      }

      .video-wrapper {
        margin: 0;
        border-radius: 0;
        height: 100%;
        width: 100%;
      }

      /* On cache le panneau de détails desktop sur mobile car il est en overlay */
      .stream-details-panel {
        display: none;
      }

      /* Le Chat devient un overlay en bas */
      .right-column {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40%; /* Hauteur du chat sur mobile */
        z-index: 10;
        background: transparent;
        border: none;
        /* Gradient pour lisibilité sur la vidéo */
        background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, transparent 100%);
      }

      .chat-header { display: none; } /* Pas de header de chat sur mobile */

      /* Customisation du chat component pour mobile (via ::ng-deep si nécessaire ou styles globaux, 
         mais ici on assume que le composant gère sa transparence) */
      
      .profile-pill {
        top: 15px; left: 15px;
        background: rgba(0,0,0,0.4);
      }

      .mobile-close-btn {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: rgba(255,255,255,0.2);
        border: none;
        color: white;
        z-index: 20;
        display: flex; align-items: center; justify-content: center;
      }

      .mobile-controls {
        position: absolute;
        bottom: 20px;
        right: 15px;
        z-index: 20;
        display: flex;
        flex-direction: column;
        gap: 15px;
      }

      .mob-btn {
        width: 45px; height: 45px;
        border-radius: 50%;
        border: none;
        color: white;
        font-size: 1.2rem;
        display: flex; align-items: center; justify-content: center;
      }
      .mob-btn.share { background: rgba(59, 130, 246, 0.8); }
      .mob-btn.report { background: rgba(180, 83, 9, 0.85); }
      .mob-btn.like { background: rgba(239, 68, 68, 0.8); }
    }
    `,
  ],
})
export class ViewerComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("remoteVideo") remoteVideo!: ElementRef;

  slug: string = "";
  stream: any | null = null;
  viewerCount: number = 0;
  viewers: Viewer[] = [];
  isVideoInitialized: boolean = false;
  currentUserId: any = "0";
  autoplayFailed: boolean = false;
  broadcasterName: string = "";
  broadcasterProfilePicture: string = "";
  isChatEnabled: boolean = true;
  showShareModal: boolean = false;
  shareUrl: string = "";
  shareTitle: string = "";
  paymentRequired: boolean = false;
  showReportModal: boolean = false;
  showStreamEndedModal: boolean = false;
  streamEndedMessage: string = "Le live est terminé. Merci d'avoir regardé !";
  private hasStreamEnded: boolean = false;
  reportReasons = STREAM_REPORT_REASONS;
  selectedReportReason: string = '';
  reportDetails: string = '';
  submittingReport: boolean = false;
  private liveElapsedTick = 0;
  private liveElapsedIntervalId: ReturnType<typeof setInterval> | undefined;
  private subscriptions: Subscription[] = [];
  private baseApiUrl = environment.apiUrl;
  private httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "",
    }),
  };

  private agoraRTCModule: any | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private agoraService: AgoraService,
    private authService: AuthService,
    private http: HttpClient,
    private viewersService: ViewersService,
    private secureStorage: SecureStorageService,
    private chatService: ChatService,
    private modalService: NgbModal,
    private livePaymentService: LivePaymentService,
    private notificationService: NotificationService,
    private streamService: StreamService
  ) {
    this.slug = this.route.snapshot.params["slug"];
    this.currentUserId = getCurrentUserId() || "0";

    const token = this.secureStorage.getItem<string>("token") || "";
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    };
  }

  private async getAgoraRTC(): Promise<any> {
    if (typeof window === "undefined") {
      throw new Error("AgoraRTC est disponible uniquement côté navigateur (SSR désactivé).");
    }
    if (this.agoraRTCModule) return this.agoraRTCModule;
    const mod: any = await import("agora-rtc-sdk-ng");
    this.agoraRTCModule = mod?.default ?? mod;
    return this.agoraRTCModule;
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.slug = params["slug"];
      if (this.slug) {
        this.loadStreamInfo();
        this.viewersService.loadViewers(this.slug);

        this.subscriptions.push(
          this.viewersService.viewers$.subscribe((viewers) => {
            this.viewers = viewers;
          })
        );

        this.subscriptions.push(
          this.viewersService.totalViewers$.subscribe((count) => {
            this.viewerCount = count;
          })
        );

        this.subscriptions.push(
          this.viewersService.streamEnded$.subscribe((data) => {
            if (data?.slug === this.slug) {
              this.handleStreamEnded(data.message);
            }
          })
        );
      }
    });

    this.subscriptions.push(
      this.agoraService.onVideoSourceChanged().subscribe(() => {
        console.log("Source vidéo changée, réinitialisation de la lecture");
        this.handleVideoSourceChange();
      })
    );

    this.getChatState();

    this.chatService.getInitialChatState(this.slug).subscribe({
      next: (state) => {
        this.isChatEnabled = state;
      },
    });

    this.chatService.getChatState$().subscribe({
      next: (state) => {
        this.isChatEnabled = state;
      },
      error: (error) => {
        console.error("Viewer - Erreur écoute chat:", error);
      },
    });

    this.liveElapsedIntervalId = setInterval(() => {
      this.liveElapsedTick = Date.now();
    }, 1000);
  }

  /** Durée depuis le début du live (started_at), comme sur mobile. */
  get liveElapsedDisplay(): string {
    void this.liveElapsedTick;
    return formatStreamElapsed(this.stream?.started_at);
  }

  private getChatState() {
    // Logic placeholder
  }

  private loadStreamInfo(): void {
    this.agoraService.getStreamInfo(this.slug).subscribe({
      next: (response: any) => {
        const streamData = response?.data ?? response;
        this.stream = streamData;
        if (this.stream?.user) {
          const user = this.stream.user as any;
          this.broadcasterName =
            (this.stream.user.prenom || "") +
            " " +
            (this.stream.user.name || "Broadcaster");
          this.broadcasterProfilePicture =
            this.stream.user.profile_picture ||
            "assets/images/avatar.jpeg";
        } else {
          this.broadcasterName = "Broadcaster";
          this.broadcasterProfilePicture = "assets/images/avatar.jpeg";
        }

        const streamForCheck: Stream = {
          ...this.stream,
          free: this.stream?.free,
          price: this.stream?.price,
          user_id: this.stream?.user_id,
        };
        if (isStreamPaid(streamForCheck) && !this.isOwner(streamForCheck)) {
          this.agoraService.hasPaidForStream(this.slug).subscribe({
            next: (res) => {
              if (res.has_paid) {
                this.initializeViewer();
              } else {
                this.paymentRequired = true;
                this.openLivePaymentModalThenJoin(streamForCheck);
              }
            },
            error: () => {
              this.notificationService.error("Impossible de vérifier l'accès au live.");
              this.router.navigate(["/streams"]);
            },
          });
        } else {
          this.initializeViewer();
        }
      },
      error: (error) => {
        const status = error?.status ?? error?.error?.status;
        if (status === 402) {
          this.notificationService.error(
            "Paiement requis pour accéder à ce live."
          );
        }
        console.error(
          "Erreur lors du chargement des informations du stream:",
          error
        );
        this.router.navigate(["/streams"]);
      },
    });
  }

  private isOwner(stream: Stream | any): boolean {
    const uid = getCurrentUserId();
    if (!uid || stream?.user_id == null) return false;
    return String(stream.user_id) === String(uid);
  }

  /** Spectateur connecté, pas le diffuseur, live encore « live ». */
  canReportStream(): boolean {
    if (!this.stream || this.stream.status !== "live") {
      return false;
    }
    const token = this.secureStorage.getItem<string>("token");
    if (!token) {
      return false;
    }
    return !this.isOwner(this.stream);
  }

  openReportModal(): void {
    if (!this.canReportStream()) {
      this.notificationService.create(
        "Connectez-vous pour signaler ce live.",
        "warning",
        4000
      );
      return;
    }
    this.selectedReportReason = "";
    this.reportDetails = "";
    this.showReportModal = true;
  }

  closeReportModal(): void {
    this.showReportModal = false;
    this.submittingReport = false;
  }

  submitReport(): void {
    if (!this.selectedReportReason || !this.slug) {
      return;
    }
    this.submittingReport = true;
    const details = this.reportDetails?.trim() || undefined;
    this.streamService
      .reportStream(this.slug, {
        reason: this.selectedReportReason,
        details,
      })
      .subscribe({
        next: () => {
          this.submittingReport = false;
          this.closeReportModal();
          this.notificationService.success("Signalement enregistré. Merci.");
        },
        error: (err: any) => {
          this.submittingReport = false;
          const status = err?.status;
          const msg =
            err?.error?.message ||
            (status === 409
              ? "Vous avez déjà signalé ce live."
              : "Impossible d’envoyer le signalement.");
          if (status === 409) {
            this.notificationService.create(msg, "warning", 5000);
          } else {
            this.notificationService.error(msg);
          }
        },
      });
  }

  private openLivePaymentModalThenJoin(stream: Stream | any): void {
    const amount = stream?.price ?? 0;
    if (amount <= 0) {
      this.initializeViewer();
      return;
    }
    const reference = `LIVE-${Date.now()}-${Math.floor(Math.random() * 999999)}`;
    this.livePaymentService
      .createStreamPayment({
        stream_id: stream.id,
        amount,
        currency: "USD",
        reference,
        type_payment_id: 2,
        source: "web",
      })
      .subscribe({
        next: (res) => {
          const ref = res.data?.reference ?? reference;
          const modalRef = this.modalService.open(PaymentModalComponent, {
            size: "md",
            centered: true,
            backdrop: "static",
            keyboard: false,
          });
          modalRef.componentInstance.amount = amount;
          modalRef.componentInstance.currency = "USD";
          modalRef.componentInstance.reference = ref;
          modalRef.componentInstance.transactionId = ref;
          modalRef.componentInstance.isLivePayment = true;
          modalRef.componentInstance.streamSlug = stream.slug;
          modalRef.result
            .then(
              (result: any) => {
                if (result?.success) {
                  this.notificationService.success(
                    "Paiement réussi. Vous pouvez accéder au live."
                  );
                  this.paymentRequired = false;
                  this.initializeViewer();
                } else {
                  this.paymentRequired = false;
                  this.router.navigate(["/streams"]);
                }
              },
              () => {
                this.paymentRequired = false;
                this.router.navigate(["/streams"]);
              }
            )
            .catch(() => {
              this.paymentRequired = false;
              this.router.navigate(["/streams"]);
            });
        },
        error: () => {
          this.paymentRequired = false;
          this.notificationService.error(
            "Impossible de charger les données de paiement."
          );
          this.router.navigate(["/streams"]);
        },
      });
  }

  private async handleVideoSourceChange(): Promise<void> {
    try {
      const remoteVideoTrack = this.agoraService.getRemoteVideoTrack();
      if (remoteVideoTrack) {
        await remoteVideoTrack.stop();
      }
      this.isVideoInitialized = false;
      this.autoplayFailed = true;
      await new Promise((resolve) => setTimeout(resolve, 500));
      await this.playVideo();
    } catch (error) {
      console.error("Erreur changement source:", error);
      this.autoplayFailed = true;
    }
  }

  private async initializeViewer(): Promise<void> {
    try {
      this.autoplayFailed = true;
      const AgoraRTC = await this.getAgoraRTC();
      AgoraRTC.onAutoplayFailed = () => {
        this.autoplayFailed = true;
      };

      const currentUser = this.authService.getCurrentUser();
      let userId = currentUser ? currentUser.id : Math.floor(Math.random() * 1000000);

      await this.agoraService.initializeViewer(this.slug, userId);
      this.notifyJoinStream();
      this.agoraService.subscribeToVideoSourceChanges();
    } catch (error) {
      console.error("Erreur init viewer:", error);
    }
  }

  private notifyJoinStream(): void {
    const token = this.secureStorage.getItem<string>("token");
    if (!token) return;
    this.http
      .post(`${this.baseApiUrl}/streams/${this.slug}/join`, {}, this.httpOptions)
      .subscribe({
        next: () => {},
        error: (err) => {
          const status = err?.status ?? err?.error?.status;
          if (status === 402 && this.stream) {
            this.agoraService.stopStreaming();
            this.isVideoInitialized = false;
            this.autoplayFailed = false;
            this.paymentRequired = true;
            this.notificationService.error(
              "Paiement requis pour accéder à ce live."
            );
            this.openLivePaymentModalThenJoin(this.stream);
          }
        },
      });
  }

  private notifyLeaveStream(): void {
    const token = this.secureStorage.getItem<string>("token");
    if (!token) return;
    this.http
      .post(`${this.baseApiUrl}/streams/${this.slug}/leave`, {}, this.httpOptions)
      .subscribe();
  }

  async playVideo(): Promise<void> {
    this.autoplayFailed = false;
    try {
      const remoteVideoTrack = this.agoraService.getRemoteVideoTrack();
      if (remoteVideoTrack) {
        await remoteVideoTrack.stop();
        await new Promise((resolve) => setTimeout(resolve, 100));
        await remoteVideoTrack.play(this.remoteVideo.nativeElement);
        this.isVideoInitialized = true;
      } else {
        this.autoplayFailed = true;
        await this.initializeViewer();
      }
    } catch (error) {
      this.autoplayFailed = true;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.isVideoInitialized) {
        this.autoplayFailed = true;
      }
    }, 1000);
  }

  leaveStream() {
    this.notifyLeaveStream();
    this.agoraService.leaveStream(this.slug).subscribe({
      next: () => this.router.navigate(["/"]),
      error: () => this.router.navigate(["/"]),
    });
  }

  private handleStreamEnded(message?: string): void {
    if (this.hasStreamEnded || this.showStreamEndedModal) return;
    this.hasStreamEnded = true;
    if (message) {
      this.streamEndedMessage = message;
    }
    this.agoraService.stopStreaming();
    this.showStreamEndedModal = true;
  }

  onStreamEndedOk(): void {
    this.showStreamEndedModal = false;
    this.viewersService.unsubscribeFromViewersUpdates(this.slug);
    this.router.navigate(["/"]);
  }

  openShareModal() {
    this.shareUrl = `${window.location.origin}/stream/${this.slug}/view`;
    this.shareTitle = this.stream?.title || "Regardez ce live !";
    this.showShareModal = true;
  }

  closeShareModal() {
    this.showShareModal = false;
  }

  ngOnDestroy(): void {
    if (this.liveElapsedIntervalId != null) {
      clearInterval(this.liveElapsedIntervalId);
    }
    if (!this.hasStreamEnded) {
      this.notifyLeaveStream();
    }
    this.viewersService.unsubscribeFromViewersUpdates(this.slug);
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.agoraService.stopStreaming();
  }
}